import { useEffect, useState } from "react";
import { ModulesAnimation, useBrandAnimation } from "@/components/common/BrandAnimation";

/**
 * Intro (før sliden med riggen): berre den animerte Stord-logoen frå innloggingssida, midt på ei roleg navy-flate –
 * same grid og omfarging som på login. Eit stille hint «trykk for å starta» kjem etter nokre sekund. Klikk/→ går
 * vidare til forsida, der rigg-animasjonen startar.
 */
export default function IntroSlide() {
  const anim = useBrandAnimation({ onNavy: true });
  const [hint, setHint] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setHint(true), 3200);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="pres-intro" data-testid="pres-slide-intro">
      <div className="module-grid-bg pres-intro-grid" aria-hidden />
      <div className="pres-intro-glow" aria-hidden />
      <div className="pres-intro-figure pres-in" style={{ "--i": 1 }}>
        <ModulesAnimation data={anim} className="w-full pres-intro-anim" testId="pres-intro-animation" />
      </div>
      <div className="pres-intro-hint" data-on={hint ? "true" : "false"} data-testid="pres-intro-hint" aria-hidden={!hint}>
        Trykk for å starta <kbd>→</kbd>
      </div>
    </div>
  );
}
